import React from "react";
import { Modal, Avatar, Button } from "antd";
import { getInitials } from "utility/helperFunctions";
import { modalStyles } from "./data";


export const RiderDetailModal = ({
    open,
    onClose,
    riderData
}) => {
    if (!riderData) return null;

    const handleClose = () => {
        onClose();
    };

    const formatPhoneNumber = (phoneNumber) => {
        return phoneNumber ? `+91-${phoneNumber}` : "N/A";
    };

    const formatEmail = (email) => {
        return email || "N/A";
    };

    const formatBloodGroup = (bloodGroup) => {
        return bloodGroup || "N/A";
    };

    return (
        <Modal
            title={null}
            open={open}
            onCancel={handleClose}
            footer={null}
            closable={false}
            centered
            style={modalStyles.modal}
            bodyStyle={{ padding: "16px 16px 8px 16px" }}
        >
            {/* Modal Header */}
            <div style={modalStyles.header}>
                Rider Details
                <hr style={{
                    border: "none",
                    borderTop: "1px solid #e0e0e0",
                }} />
            </div>


            {/* Rider Info Section */}
            <div style={modalStyles.riderInfo}>
                <Avatar
                    size={48}
                    src={riderData.profilePic}
                    style={{
                        backgroundColor: "#87d068",
                        ...modalStyles.avatar
                    }}
                >
                    {!riderData.profilePic && getInitials(riderData.firstName, riderData.lastName)}
                </Avatar>
                <div>
                    <h3 style={modalStyles.riderName}>
                        {riderData.firstName} {riderData.lastName}
                    </h3>
                    <p style={modalStyles.userName}>
                        @{riderData.userName}
                    </p>
                </div>
            </div>

            {/* Fields Container - Two column layout */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                {/* Contact Number Field */}
                <div style={modalStyles.fieldContainer}>
                    <label style={modalStyles.fieldLabel}>
                        CONTACT NUMBER
                    </label>
                    <div style={modalStyles.fieldValue}>
                        {formatPhoneNumber(riderData?.phoneNumber)}
                    </div>
                </div>

                {/* Email Field */}
                <div style={modalStyles.fieldContainer}>
                    <label style={modalStyles.fieldLabel}>
                        EMAIL
                    </label>
                    <div style={modalStyles.fieldValue}>
                        {formatEmail(riderData?.email)}
                    </div>
                </div>

                {/* Emergency Contact Field */}
                <div style={modalStyles.fieldContainer}>
                    <label style={modalStyles.fieldLabel}>
                        EMERGENCY CONTACT
                    </label>
                    <div style={modalStyles.fieldValue}>
                        {formatPhoneNumber(riderData?.emergencyContactNo)}
                    </div>
                </div>

                {/* Blood Group Field */}
                <div style={modalStyles.fieldContainer}>
                    <label style={modalStyles.fieldLabel}>
                        BLOOD GROUP
                    </label>
                    <div style={modalStyles.fieldValue}>
                        {formatBloodGroup(riderData.bloodGroup)}
                    </div>
                </div>
            </div>

            {/* Close Button */}
            <div style={modalStyles.buttonContainer}>
                <Button
                    type="primary"
                    onClick={handleClose}
                    style={modalStyles.okButton}
                >
                    Okay
                </Button>
            </div>
        </Modal>
    );
};
